
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.5 4.25l.788 5.515c.141.989.212 1.986.212 2.985a22.8 22.8 0 01-.542 4.94L.5 19.75m1-7h5a1 1 0 011 1v6m4.5-.5v-9.5m-6 0h12m-8.5 10h5m8-7h-5a1 1 0 00-1 1v6m7-15.5l-.788 5.515a21.143 21.143 0 00-.212 2.985 22.8 22.8 0 00.542 4.94l.458 2.06","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    